<template lang="pug">
  #ItemsListIndex.container-width
    h5.text-center.pt-2 我的工作管理
    b-card.rounded-0(
      bg-variant="light",
      v-for="(router,index) in routers",
      :key="index"
    )
      router-link(
        :to="{name: router.routerPushName ? router.routerPushName : 'sm-items-list-index'}"
      )
        .row.no-gutters
          .col-2.pr-1.text-center
            //- Use Font Awesome Icon
            i.fa-lg(
              :class="router.iconClassName",
              style="font-size: 1.5rem;"
            )
          .col-10.pl-1
            span {{ router.name }}
</template>

<script>
import { SM_RESERVATION_INDEX } from '@/router/sm/reservation';
// import { SM_CONTACTS_INDEX } from '@/router/sm/contacts';
import { SM_LABEL_INDEX } from '@/router/sm/label';
import { SM_STORES_MANAGER_INDEX } from '@/router/sm/stores-manager';
// import { SM_PROFILE_INDEX } from '@/router/sm/profile';

export default {
  name: 'ItemsListIndex',
  data() {
    return {
      routers: [
        {
          name: '我的預約',
          iconClassName: 'far fa-calendar-check',
          routerPushName: SM_RESERVATION_INDEX
        },
        {
          name: '我的顧客',
          iconClassName: 'fas fa-users',
          routerPushName: null
        },
        {
          name: '顧客標籤',
          iconClassName: 'fas fa-tag',
          routerPushName: SM_LABEL_INDEX
        },
        {
          name: '店鋪管理',
          iconClassName: 'fas fa-store',
          routerPushName: SM_STORES_MANAGER_INDEX
        },
        {
          name: '修改個人資料',
          iconClassName: 'fas fa-edit',
          routerPushName: null
        }
      ]
    };
  },
  mounted() {
    this.$store.commit('toggleLoading', false);
  }
};
</script>

<style>

</style>
